import { $_trans, dayjsWithTz } from "vue-app/utils/functions";
import { getDateInAccountTimezoneFromLocalTimezone } from "./datesDatepicker";

type DatepickerShortcut = {
  text: string;
  onClick: () => [Date, Date];
};
const today: DatepickerShortcut = {
  text: $_trans("Today"),
  onClick: () => {
    const today = dayjsWithTz();
    const dateFrom = today.startOf("day").toDate();
    const dateTo = today.endOf("day").toDate();
    return [getDateInAccountTimezoneFromLocalTimezone(dateFrom), getDateInAccountTimezoneFromLocalTimezone(dateTo)];
  },
};
const last7days: DatepickerShortcut = {
  text: $_trans("last7Days"),
  onClick: () => {
    const last7daysDay = dayjsWithTz().subtract(7, "day");
    const dateFrom = last7daysDay.startOf("day").toDate();
    const dateTo = dayjsWithTz().subtract(1, "day").endOf("day").toDate();
    return [getDateInAccountTimezoneFromLocalTimezone(dateFrom), getDateInAccountTimezoneFromLocalTimezone(dateTo)];
  },
};
const last30days: DatepickerShortcut = {
  text: $_trans("last30Days"),
  onClick: () => {
    const last30daysDay = dayjsWithTz().subtract(30, "day");
    const dateFrom = last30daysDay.startOf("day");
    const dateTo = dayjsWithTz().subtract(1, "day").endOf("day");
    return [
      getDateInAccountTimezoneFromLocalTimezone(dateFrom.toDate()),
      getDateInAccountTimezoneFromLocalTimezone(dateTo.toDate()),
    ];
  },
};
const last90days: DatepickerShortcut = {
  text: $_trans("last90Days"),
  onClick: () => {
    const last90daysDay = dayjsWithTz().subtract(3, "month");
    const dateFrom = last90daysDay.startOf("month");
    const dateTo = dayjsWithTz().subtract(1, "day").endOf("day");
    return [
      getDateInAccountTimezoneFromLocalTimezone(dateFrom.toDate()),
      getDateInAccountTimezoneFromLocalTimezone(dateTo.toDate()),
    ];
  },
};
const lastYear: DatepickerShortcut = {
  text: $_trans("lastYear"),
  onClick: () => {
    const dateFrom = dayjsWithTz().subtract(1, "year");
    const dateTo = dayjsWithTz().subtract(1, "day").endOf("day");
    return [
      getDateInAccountTimezoneFromLocalTimezone(dateFrom.toDate()),
      getDateInAccountTimezoneFromLocalTimezone(dateTo.toDate()),
    ];
  },
};
const datesDatepickerShortcuts = [today, last7days, last30days, last90days, lastYear];
const datesDatepickerShortcutsWithoutToday = [last7days, last30days, last90days, lastYear];

// Temporary export for orders page
export const tempDatesDatepickerShortcutsForOrders = [today, last7days, last30days];

export { datesDatepickerShortcuts, datesDatepickerShortcutsWithoutToday };
